var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="region-header" class="workspace-header"></div>\n<div class="workspace-content multi-column blackline">\n	<div id="region-table" class="column no-scroll blackline-left">\n		<p>Loading blackline interface...</p>\n	</div>\n	<div class="column no-scroll blackline-right">\n		<div id="region-selected"></div>\n		<div id="region-catalogue"></div>\n	</div>\n</div>\n';
}
return __p;
};
